import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import Messages from "./Messages.vue";
import DetailsCard from "./DetailsCard.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import MessageBox from "./MessageBox.vue";
export default {
  name: "Details.vue",
  components: {
    Messages: Messages,
    DetailsCard: DetailsCard,
    PageTitle: PageTitle,
    MessageBox: MessageBox
  },
  data: function data() {
    return {
      ticket: null
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  mounted: function mounted() {
    this.getTicketDetails();
  },
  methods: {
    getTicketDetails: function getTicketDetails() {
      var _this = this;

      var ticketId = this.$route.params.id;
      providerApiService.getTicketDetails(this.currentProvider.id, ticketId).then(function (result) {
        return _this.ticket = result.data;
      });
    },
    onClickButton: function onClickButton() {
      this.$router.back();
    },
    replyTicket: function replyTicket() {
      this.$refs["messageBoxRef"].toggleMessageBoxVisibility();
    },
    onTicketReplied: function onTicketReplied(ticket) {
      this.ticket = ticket;
    }
  }
};